import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'

const OLDEST_VEHICLE_YEAR = 1980

/** Model years run a year ahead of the calendar, so the list starts at next year. No default. */
export const buildVehicleYearOptions = (currentYear: number): BasicSelectOption[] => {
  const newestYear = currentYear + 1

  return Array.from({ length: newestYear - OLDEST_VEHICLE_YEAR + 1 }, (_unused, index) => {
    const year = String(newestYear - index)

    return { label: year, value: year }
  })
}
